import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtEur, fmtMwhc } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";

const Row = ({ r, total }) => (
  <tr className={total ? "border-t-2 border-border bg-secondary/60 font-bold" : "border-t border-border"} data-testid={`admin-stats-row-${r.id}`}>
    <td className="px-4 py-3">
      {r.name}
      {r.active === false && <Badge variant="outline" className="ml-2 border-destructive text-destructive">désactivé</Badge>}
    </td>
    <td className="px-4 py-3 text-right metric" data-testid={`admin-stats-count-${r.id}`}>{r.projects_count}</td>
    <td className="px-4 py-3 text-right metric" data-testid={`admin-stats-kwhc-${r.id}`}>{fmtMwhc(r.total_kwhc)}</td>
    <td className="px-4 py-3 text-right metric font-semibold" data-testid={`admin-stats-prime-${r.id}`}>{fmtEur(r.total_prime)}</td>
  </tr>
);

export const AdminStats = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setData(r.data)); }, []);

  return (
    <Card className="overflow-hidden" data-testid="admin-stats">
      <div className="p-4 border-b border-border">
        <div className="font-heading font-bold">Récapitulatif par espace</div>
        <div className="text-xs text-muted-foreground">Totaux depuis le début, toutes simulations enregistrées.</div>
      </div>
      {!data ? (
        <div className="grid place-items-center py-10"><Loader2 className="h-6 w-6 animate-spin text-genis" /></div>
      ) : (
        <table className="w-full text-sm" data-testid="admin-stats-table">
          <thead>
            <tr className="bg-secondary/60 text-left">
              <th className="px-4 py-3 font-semibold">Espace</th>
              <th className="px-4 py-3 font-semibold text-right">Dossiers</th>
              <th className="px-4 py-3 font-semibold text-right">Volume CEE</th>
              <th className="px-4 py-3 font-semibold text-right">Prime totale</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => <Row key={r.id} r={r} />)}
            <Row r={{ id: "total", name: "Total", ...data.total }} total />
          </tbody>
        </table>
      )}
    </Card>
  );
};
